<template>
  <div>
    <div class="form-group row">
      <label :for="safeId('name')" class="col-sm-4 col-form-label">Name</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" :id="safeId('name')" v-model.trim="localName">
      </div>
    </div>
    <div class="form-group row">
      <label :for="safeId('columns')" class="col-sm-4 col-form-label">Columns</label>
      <div class="col-sm-8">
        <textarea class="form-control" :id="safeId('columns')" rows="5" v-model="localColumns"></textarea>
      </div>
    </div>
    <div class="form-group row justify-content-end">
      <div class="col-sm-8">
        <button type="button" class="btn btn-primary" @click="save">Save</button>
        <button type="button" class="btn btn-secondary" @click="reset">Cancel</button>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4 col-form-label">Danger zone</label>
      <div class="col-sm-8">
        <p class="form-text">Once you delete a dataset, there is no going back. Please be certain. </p>
        <button type="button" class="btn btn-danger" @click="remove">Delete Dataset</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { windowPropsMixin } from '../mixins'
  import * as action from '../store/action-types'
  import * as mutation from '../store/mutation-types'

  export default {
    name: 'dataset-settings',
    mixins: [windowPropsMixin],
    props: ['datasetId'],
    data () {
      return {
        localName: '',
        localColumns: ''
      }
    },
    computed: {
      dataset () {
        return this.$store.getters.dataset(this.datasetId)
      },
      computedName () {
        return this.dataset.name || this.windowTitle
      },
      computedColumns () {
        return this.dataset.columns.join('\n')
      }
    },
    created () {
      this.reset()
    },
    watch: {
      computedName: function (val) {
        this.localName = val
      },
      computedColumns: function (val) {
        this.localColumns = val
      }
    },
    methods: {
      save () {
        this.windowTitle = this.localName
        this.$store.commit(mutation.DATASET_UPDATE_META, {
          datasetId: this.datasetId,
          name: this.localName,
          columns: this.localColumns.split('\n'),
          emit: true
        })
      },
      reset () {
        this.localName = this.computedName
        this.localColumns = this.computedColumns
      },
      remove () {
        this.$store.dispatch(action.DATASET_DELETE, {
          windowId: this.windowId,
          datasetId: this.datasetId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dataset-settings.vue